module.exports = __webpack_public_path__ + "assets/img/login-bg@3x.a1308a05.png";